import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/Index.vue'



Vue.use(VueRouter)

const routes = [
        {
        path: '/',
        name: 'index',
        component: index
      },
      {
        path: '/proyectos',
        name: 'Proyectos',
        component: () => import(/* webpackChunkName: "proyectos" */ '../views/Proyectos.vue')
      },
      {
        path: '/nosotros',
        name: 'nosotros',
        component: () => import(/* webpackChunkName: "nosotros" */ '../views/Nosotros.vue')
      },
      {
        path: '/contacto',
        name: 'Contacto',
        component: () => import(/* webpackChunkName: "contacto" */ '../views/Contacto.vue')
      },
      {
        path: '/coockies',
        name: 'Coockies',
        component: () => import(/* webpackChunkName: "coockies" */ '../views/Coockies.vue')
      },
      {
        path: '/Politica',
        name: 'Politica',
        component: () => import(/* webpackChunkName: "politica" */ '../views/Politica.vue')
      },
      {
        path: '/legal',
        name: 'Legal',
        component: () => import(/* webpackChunkName: "legal" */ '../views/Legal.vue')
      },
      {
        path: '/ebersy',
        name: 'Ebersy',
        component: () => import(/* webpackChunkName: "ebersy" */ '../components/section/proyectos/Ebersy.vue')
      },
      {
        path: '/generarecetas',
        name: 'Generarecetas',
        component: () => import(/* webpackChunkName: "generarecetas" */ '../components/section/proyectos/Generarecetas.vue')
      },
      {
        path: '/pariciones',
        name: 'Pariciones',
        component: () => import(/* webpackChunkName: "pariciones" */ '../components/section/proyectos/Pariciones.vue')
      },
      {
        path: '/gestiongr',
        name: 'Gestiongr',
        component: () => import(/* webpackChunkName: "gestiongr" */ '../components/section/proyectos/Gestiongr.vue')
      },
      {
        path: '/toi',
        name: 'Toi',
        component: () => import(/* webpackChunkName: "toi" */ '../components/section/proyectos/Toi.vue')
      },
      {
        path: '/tikgestion',
        name: 'Tikgestion',
        component: () => import(/* webpackChunkName: "tikgestion" */ '../components/section/proyectos/Tikgestion.vue')
      },
      {
        path: '/gestion',
        name: 'Gestion',
        component: () => import(/* webpackChunkName: "gestion" */ '../components/section/proyectos/Gestion.vue')
      },
      {
        path: '/gestiongr',
        name: 'Gestiongr',
        component: () => import(/* webpackChunkName: "gestiongr" */ '../components/section/proyectos/Gestiongr.vue')
      },
      {
        path: '/huella',
        name: 'Huella',
        component: () => import(/* webpackChunkName: "huella" */ '../components/section/proyectos/Huella.vue')
      },
      {
        path: '/psi',
        name: 'Psi',
        component: () => import(/* webpackChunkName: "psi" */ '../components/section/proyectos/Psi.vue')
      },
    ]




const router = new VueRouter({
  linkActiveClass: "active",
  //base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
  
})


export default router
